import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle, AlertDialogTrigger } from "@/components/ui/alert-dialog";
import { Button } from "@/components/ui/button";
import booking from "@/shared/api/booking";
import { Trash } from "lucide-react";
import { useState } from "react";
import { toast } from "sonner";


export const DeleteRecordAlert = ({ id, handleBookingChanged }) => {
    const [isDialogOpen, setIsDialogOpen] = useState(false);

    const handleBookingDelete = async () => {
        try {
            const res = await booking.deleteBooking(id);
            if (res) {
                toast.success("Запись успешно удалена");

                handleBookingChanged((prev) => {
                    if (!prev) return new Map();

                    const newMap = new Map(prev);

                    // Найдём дату, в которой есть запись с этим id
                    for (const [date, bookings] of newMap.entries()) {
                        const filtered = bookings.filter((b) => b._id !== id);
                        if (filtered.length !== bookings.length) {
                            // Если запись была удалена — обновляем Map
                            if (filtered.length === 0) {
                                newMap.delete(date); // если больше нет записей на этот день
                            } else {
                                newMap.set(date, filtered);
                            }
                            break;
                        }
                    }

                    return newMap;
                });
            } else {
                toast.error("Ошибка при удалении записи");
            }
        } catch (error) {
            toast.error("Ошибка при удалении записи");
            console.error(error);
        }
    }

    return (
        <AlertDialog open={isDialogOpen} onOpenChange={setIsDialogOpen}>
            <AlertDialogTrigger asChild>
                <Button variant="outline">
                    <Trash className="h-4 w-4" />
                </Button>
            </AlertDialogTrigger>
            <AlertDialogContent>
                <AlertDialogHeader>
                    <AlertDialogTitle>Подтверждение действия</AlertDialogTitle>
                    <AlertDialogDescription>
                        Вы уверены, что хотите удалить запись <strong>{booking.name}</strong>?
                        Все данные будут удалены безвозвратно.
                    </AlertDialogDescription>
                </AlertDialogHeader>
                <AlertDialogFooter>
                    <AlertDialogCancel>Отмена</AlertDialogCancel>
                    <AlertDialogAction onClick={() => handleBookingDelete()}>
                        Подтвердить
                    </AlertDialogAction>
                </AlertDialogFooter>
            </AlertDialogContent>
        </AlertDialog>
    )
}